import { render, staticRenderFns } from "./TopAffiliates.vue?vue&type=template&id=1221998d&"
import script from "./TopAffiliates.vue?vue&type=script&lang=js&"
export * from "./TopAffiliates.vue?vue&type=script&lang=js&"
import style0 from "./TopAffiliates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports